import { combineReducers } from 'redux';
import checkCoverageReducer from './checkCoverageReducer';

export default combineReducers({
  womanProduct: checkCoverageReducer,
});
